export class ListPagingSetItemsPerPageAction {
  constructor(public itemsPerPage: number) {}
}
